import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Property } from 'src/app/models';
import { ChallengePropertyDialogData } from './challenge-property-dialog.viewmodel';

@Component({
  selector: 'app-challenge-property-dialog',
  templateUrl: './challenge-property-dialog.component.html',
  styleUrls: ['./challenge-property-dialog.component.css']
})
export class ChallengePropertyDialogComponent implements OnInit {

  property: Property;
  form!: FormGroup;

  get notes() { return this.form.get('notes') as FormControl; }

  constructor(
    private dialogRef: MatDialogRef<ChallengePropertyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ChallengePropertyDialogData
  ) {
    this.property = data.property;
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    // Initialize formgroup
    this.form = new FormGroup({
      notes: new FormControl()
    });
  }

  close() {
    this.dialogRef.close();
  }

  onSubmit(f: any) {
    this.dialogRef.close(this.result());
  }

  result() {
    return {
      propertyID: this.property._id,
      notes: this.notes.value,
    };
  }
}
